import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { MembershipIcon } from "../../general/Icons";
import { useTranslation } from "react-i18next";

const Memberships = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { membershipAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const membershipAdjustmentElements = useMemo(() => {
    return membershipAdjustments?.map(
      ({ adjustment, associatedTaxes }, index) => (
        <AdjustmentItem
          key={`membership-${index}`}
          adjustment={adjustment}
          taxes={associatedTaxes}
        />
      )
    );
  }, [membershipAdjustments]);

  if (!membershipAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="memberships-container">
      <div className="flex items-center gap-2 mb-2" data-testid="memberships-header">
        <MembershipIcon />
        <h3 className="text-lg font-medium text-black" data-testid="memberships-title">
          {t("ticketItemsSections.memberships")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="memberships-list">{membershipAdjustmentElements}</div>
    </div>
  );
};

export default Memberships;
